import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
  ],
  exports: [],
  providers: [],
  entryComponents: []
})
export class CommonSharedModule {}
